import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const DigitalDesign = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="90" viewBox="0 0 71 90" width="71" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M21.1 28.75H8.43a.86.86 0 0 0-.86.86v12.67c0 .48.38.86.86.86H21.1c.48 0 .86-.38.86-.86V29.61a.86.86 0 0 0-.86-.86Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M65.1 29.3H52.44a.86.86 0 0 0-.85.87v12.67c0 .48.38.86.85.86h12.68c.47 0 .86-.38.86-.86V30.17a.86.86 0 0 0-.86-.86Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M63.5 69.5H50.82a.86.86 0 0 0-.85.87v12.67c0 .48.38.86.85.86H63.5c.47 0 .86-.38.86-.86V70.37a.86.86 0 0 0-.86-.86Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M21.1 69.5H8.43a.86.86 0 0 0-.86.87v12.67c0 .48.38.86.86.86H21.1c.48 0 .86-.38.86-.86V70.37a.86.86 0 0 0-.86-.86Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M54.75 31.92H12.46a.86.86 0 0 0-.86.86v39.05c0 .47.39.85.86.85h42.3c.46 0 .85-.38.85-.85V32.78a.86.86 0 0 0-.86-.86Z"
        strokeWidth={strokeWidth}
      />
      <path d="M42.83 46.15v12.3h-6.15V52.3h-6.14v6.14h-6.15V46.15z" fill={shades.black} />
      <path
        className={strokeStyle}
        d="M17.94 24.72H5.26a.86.86 0 0 0-.86.86v12.68c0 .47.39.86.86.86h12.68c.47 0 .85-.39.85-.86V25.58a.86.86 0 0 0-.85-.86Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M61.95 25.28H49.27a.86.86 0 0 0-.85.86v12.68c0 .47.38.86.85.86h12.68c.47 0 .86-.39.86-.86V26.14a.86.86 0 0 0-.86-.86Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M60.34 65.48H47.66a.86.86 0 0 0-.85.86v12.68c0 .47.38.86.85.86h12.68c.47 0 .86-.39.86-.86V66.34a.86.86 0 0 0-.86-.86Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M17.94 65.48H5.26a.86.86 0 0 0-.86.86v12.68c0 .47.39.86.86.86h12.68c.47 0 .85-.39.85-.86V66.34a.86.86 0 0 0-.85-.86Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M33.6 31.92V11.36" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M33.68 19.88a7.14 7.14 0 1 0 0-14.28 7.14 7.14 0 0 0 0 14.28Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
